import { CommonTable } from "components";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { getColumns } from "./getColumns";

export const WithdrawalRequestsList = observer(() => {
  const { user, rubWithdrawalRequests } = useStores();

  return (
    <CommonTable
      id="wr-table"
      store={rubWithdrawalRequests}
      columns={getColumns(rubWithdrawalRequests, user)}
      whiteBox
      updateWithInterval
    />
  );
});
